// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"598b2dc8","453":"cc046f75"}[chunkId] + ".chunk.js";
};